import {
    type FullDate,
    fullDateZodSchema,
} from "@@/shared/date-time/full-date";
import { type Timezone, timezoneZodType } from "@@/shared/date-time/timezone";
import { z } from "zod";
import {
    type _ReportItemBase,
    _reportItemBaseZodSchema,
} from "../shared/_report-item-base";
import { type MonthlyTotals, monthlyTotalsZodSchema } from "./monthly-totals";

type DailyReportItem = _ReportItemBase & {
    readonly type: "DAILY";
    readonly fullDate: FullDate;
    readonly timezone: Timezone;
    readonly columnName: string;
} & MonthlyTotals;

const dailyReportItemZodSchema: z.ZodSchema<DailyReportItem> = z.intersection(
    _reportItemBaseZodSchema,
    z.intersection(
        monthlyTotalsZodSchema,
        z.object({
            type: z.literal("DAILY"),
            fullDate: fullDateZodSchema,
            timezone: timezoneZodType,
            columnName: z.string(),
        }),
    ),
);

export { dailyReportItemZodSchema };
export type { DailyReportItem };
